"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7550],{

/***/ 77550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIncendiosCircle = function SvgIncendiosCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M31.166 13.663h-17a.5.5 0 1 0 0 1h1.5v1.5a.5.5 0 0 0 .5.5h1.5v3.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-3.5h1.5a.5.5 0 0 0 .5-.5v-1.5h1.5a.5.5 0 1 0 0-1Zm-4.5 6.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3.5h8v3.5Zm2-4.5h-12v-1h12v1Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.166 19.663a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1a.5.5 0 0 0 .5.5ZM22.666 19.663a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1a.5.5 0 0 0 .5.5ZM25.167 19.663a.5.5 0 0 0 .5-.5v-1a.5.5 0 1 0-1 0v1a.5.5 0 0 0 .5.5ZM19.128 26.553a8.329 8.329 0 0 1-.405-1.083 1.75 1.75 0 0 1 .335-1.768.5.5 0 1 0-.627-.78 2.684 2.684 0 0 0-.675 2.806c.122.416.272.823.451 1.217.164.357.3.724.41 1.1a1.736 1.736 0 0 1-.35 1.761.5.5 0 1 0 .614.79 2.656 2.656 0 0 0 .706-2.8 8.983 8.983 0 0 0-.46-1.243ZM23.128 26.553a8.329 8.329 0 0 1-.405-1.083 1.75 1.75 0 0 1 .335-1.768.5.5 0 0 0-.627-.78 2.684 2.684 0 0 0-.675 2.806c.122.416.272.823.451 1.217.164.356.3.724.41 1.1a1.735 1.735 0 0 1-.352 1.758.5.5 0 1 0 .613.79 2.655 2.655 0 0 0 .706-2.8 8.979 8.979 0 0 0-.456-1.24ZM27.128 26.553a8.329 8.329 0 0 1-.405-1.083 1.75 1.75 0 0 1 .335-1.768.5.5 0 0 0-.627-.78 2.684 2.684 0 0 0-.675 2.806c.122.416.272.823.451 1.217.164.356.3.724.41 1.1a1.735 1.735 0 0 1-.352 1.758.5.5 0 1 0 .613.79 2.655 2.655 0 0 0 .706-2.8 8.979 8.979 0 0 0-.456-1.24Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 1.167,
    y: 1.163,
    width: 42,
    height: 42,
    rx: 21.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgIncendiosCircle);

/***/ })

}]);